const NAME = "PERFORMANCE_EVALUATIONS";

export default NAME;
